import { addSharingLinkInfo, tokenUnavailable } from '../actions/internalActions';
import { addSharingLink } from '../actions/subscribableActions';
import { createLinkModel } from '../selectors/createLinkModel';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-accesstoken-service';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { orchestrator } from 'satcheljs';
import { ODBSharingInfo } from 'owa-sharing-data';

orchestrator(addSharingLink, actionMessage => {
    const linkModel: SharingLinkInfo = createLinkModel(
        actionMessage.linkId,
        actionMessage.url,
        actionMessage.response,
        actionMessage.source,
        actionMessage.providerType
    );

    addSharingLinkInfo(actionMessage.linkId, linkModel);

    if (
        actionMessage.providerType === AttachmentDataProviderType.OneDrivePro &&
        !!(<ODBSharingInfo>linkModel.sharingInfo).siteUrl
    ) {
        checkforLinkToken((<ODBSharingInfo>linkModel.sharingInfo).siteUrl, actionMessage.linkId);
    }
});

async function checkforLinkToken(endpointUrl: string, linkId: string) {
    try {
        await getFileProviderAuthHeaderValue(
            AttachmentDataProviderType.OneDrivePro,
            false /* force refresh */,
            endpointUrl
        );
    } catch {
        tokenUnavailable(linkId);
    }
}
